export default __webpack_public_path__ + "static/media/Logo-por-partes-blanco.7e9959fa.png";